import React, { useCallback, useEffect, useState } from "react";
import Header from "../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Loader from "../../components/Loader";
import ReactSlider from 'react-slider'
import { FaSearch } from 'react-icons/fa';
import { useSelector } from "react-redux";
import MobileSubcategorynew from "../../components/MobileSubcategorynew";
import { gettoken } from "../../Localstorage/Store";

const CategoryMini = () => {
    const tokenvalue = gettoken();
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [hover, setHover] = useState(false);
  let { id, name, url:realurl } = useParams();
  let url = atob(realurl);
  const nvg = useNavigate();
  const [fixminprice, setfixminprice] = useState(0);
  const [fixmaxprice, setfixmaxprice] = useState(0);
  const [fixminpriceval, setfixminpriceval] = useState(0);
  const [fixmaxpriceval, setfixmaxpriceval] = useState(0);
  const [showattr, setshowattr] = useState({});
  const [brand, setbrand] = useState(true);
  const [price, setprice] = useState(true);
  const [showpages, setshowpages] = useState(false);

  const [filter, setfilter] = useState(false);
  const [currentwdith, setcurrentwdith] = useState(window.innerWidth);
  const [showsidebar, setshowsidebar] = useState(false);
  const [sortby, setsortby] = useState(false);
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [data4, setData4] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  console.log("heck seleted page val vvmmbmbmb",currentPage,data);
  const [pageSize, setpageSize] = useState(40);
  const [categroyone, setcategroyone] = useState(null);
  const [categorytwo, setcategorytwo] = useState(null);
  const [showAll, setShowAll] = useState({});
  const [showAlltwo, setShowAlltwo] = useState({});


  const handleToggleShowAll = (name) => {
    setShowAll(prevState => ({ ...prevState, [name]: !prevState[name] }));
  };

  const handleToggleShowAlltwo = (name) => {
    setShowAlltwo(prevState => ({ ...prevState, [name]: !prevState[name] }));
  };

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const filteredValues = (values) => {
    return values.filter((value) =>
      value.value_option__option?.toLowerCase().includes(searchTerm)
    );
  };




  const [filterQueries, setFilterQueries] = useState({});

  const handleFilterChange = (itemName, value) => {
    setFilterQueries(prevState => ({
      ...prevState,
      [itemName]: value,
    }));
  };


  const getFilteredValues = (item) => {
    const query = filterQueries[item.name] || '';
    if (!query) return item.values;
    return item.values.filter(item2 => item2.value_option__option.toLowerCase().includes(query.toLowerCase()));
  };
  const transfer = (productid, pname) => {
    nvg("/productdetails", {
      state: {
        id: productid,
        pname: pname,
      },
    });
    // window.location.reload();
  };

  const updateDataValue2 = (key, newData) => {
    setshowattr((prevData) => {
      const updatedData = { ...prevData, [key]: newData };
      return updatedData;
    });
  };


  const removefilter = () => {
    if (url != "none") {
      nvg(`/mini/category/${id}/${name}/${atob('none')}`);
      // window.location.reload();
    }
  }




  const mergeValues = (queryString) => {
    const params = new URLSearchParams(queryString);

    const mergedParams = Array.from(params.entries()).reduce((acc, [name, value]) => {
      acc[name] = acc[name] || new Set();
      acc[name].add(value);
      return acc;
    }, {});

    const mergedQueryString = Object.entries(mergedParams).map(([name, values]) => {
      return `&${name}=${Array.from(values).join(',')}`;
    }).join('');

    return mergedQueryString;
  };



  const updateDataValueforsort = (key, newData) => {
    let finalurl;
    let finalurl2;
    let exists = url.includes(`${key}=`);
    if (key == "max") {
      if (exists) {
        const sortByRegex = new RegExp(`${key}=[^&]+`);
        const sortByRegex2 = new RegExp(`min=[^&]+`);
        finalurl = url.replace(sortByRegex, `${key}=${newData[1]}`);
        finalurl2 = finalurl.replace(sortByRegex2, `min=${newData[0]}`);

        nvg(`/mini/category/${id}/${name}/${btoa(finalurl2)}`);
        // window.location.reload();
      } else {
        if (url == "none") {
          finalurl = `&${key}=${newData[1]}&min=${newData[0]}`;
        } else {
          finalurl = url + `&${key}=${newData[1]}&min=${newData[0]}`;
        }
        nvg(`/mini/category/${id}/${name}/${btoa(finalurl)}`);
        // window.location.reload();
      }
    } else {
      if (exists) {
        if (url == `${key}=${newData}`) {
          finalurl = "none";
        } else {
          const sortByRegex = new RegExp(`${key}=[^&]+`);
          finalurl = url.replace(sortByRegex, `${key}=${newData}`);
        }
        nvg(`/mini/category/${id}/${name}/${btoa(finalurl)}`);
        // window.location.reload();
      } else {
        if (url == "none") {
          finalurl = `&${key}=${newData}`;
        } else {
          finalurl = url + `&${key}=${newData}`;
        }
        nvg(`/mini/category/${id}/${name}/${btoa(finalurl)}`);
        // window.location.reload();
      }
    }
  };




  function transformQuery(queryString) {
    if (queryString.startsWith('&')) {
      queryString = queryString.substring(1);
    }
  
    const params = [];
    const pairs = queryString.split('&');
    
    pairs.forEach(pair => {
      const [key, value] = pair.split('=').map(decodeURIComponent);
      params.push({ key, value });
    });

    const result = {
      min: null,
      max: null,
      attributes: [] 
    };
  
    params.forEach(param => {
      if (param.key === 'min') {
        result.min = param.value;
      } 

      else if (param.key === 'max') {
        result.max = param.value;
      }

      if (param.key === 'sort') {
        result.sort = param.value;
      } 

      else if (param.key.startsWith('attr_value_')) {
        result.attributes.push(param.value);
      }
    });
  

    const combinedAttributes = result.attributes.join(',');
    
    return {
      ...result,
      combined_attributes: combinedAttributes ? `att=${combinedAttributes}` : '',
    };
  }




  
  const updateDataValue = (key, newData) => {
    let finalurl;
    let exists;
    if (key == "min" || key == "max" || key == "sort" || key == "offset") {
      exists = url.includes(`${key}=${newData}`);
      if (exists) {
        if (url == `${key}=${newData}`) {
          finalurl = "none";
        } else {

          finalurl = url.replace(`${key}=${newData}`, "");
        }
        nvg(`/mini/category/${id}/${name}/${btoa(finalurl)}`);
        // window.location.reload();
      } else {
        if (url == "none") {
          finalurl = `${key}=${newData}`;
        } else {
          finalurl = url + `&${key}=${newData}`;
        }
        nvg(`/mini/category/${id}/${name}/${btoa(finalurl)}`);
        // window.location.reload();
      }
    } else {
      exists = url.includes(`attr_name_${key}=${key}&attr_value_${key}=${newData}`);
      if (exists) {
        if (url == `&attr_name_${key}=${key}&attr_value_${key}=${newData}`) {
          finalurl = "none";
        } else {
          finalurl = url.replace(`&attr_name_${key}=${key}&attr_value_${key}=${newData}`, "");
        }
        nvg(`/mini/category/${id}/${name}/${btoa(finalurl)}`);
        // window.location.reload();
      } else {
        if (url == "none") {
          finalurl = `&attr_name_${key}=${key}&attr_value_${key}=${newData}`;
        } else {
          finalurl = url + `&attr_name_${key}=${key}&attr_value_${key}=${newData}`;
        }
        nvg(`/mini/category/${id}/${name}/${btoa(finalurl)}`);
        // window.location.reload();
      }
    }
  };
  const filterdata = useCallback(
    (data) => {
      const filterdatainner = async (attr) => {
        console.log("check atrr",attr);
        try {
          setData([]);
          let urlapi2;

          if (url == "none") {
             console.log("check 22 vv",attr)
            urlapi2 = `${process.env.REACT_APP_API_URL}homepageapi/product-list?cate=${id}&sort=new&page_number=${attr}`;
          } else {
            let checkurl = url.includes(`sort`);
            if (checkurl) {
                           console.log("check 22 nnnn")
              const outputString = mergeValues(url);
              urlapi2 = `${process.env.REACT_APP_API_URL}homepageapi/product-list?${outputString}&page_number=${attr}&cate=${id}`;
            } else {
                            console.log("check 224444")
              const outputString = mergeValues(url);
              urlapi2 = `${process.env.REACT_APP_API_URL}homepageapi/product-list?${outputString}&sort=new&page_number=${attr}&cate=${id}`;
            }

          }
       setloading(true);
          const response = await axios.get(urlapi2);
          setData([]);
          console.log("sdfghgfdsasdfghjhgfd",response)
          response.data.results
            ? setData(response.data.results)
            : setData([]);
          settotalrecords(response.data.total_items);
          handlePageClick(1);
          setTimeout(() => {
            setloading(false);
          }, 2000);
        } catch (error) {
          console.log("category error", error);
        }
      };
      filterdatainner(data);
    },
    [data]
  );



  const getLowestOrderImage = (images) => {
    if (!images || images.length === 0) return null;
    return images.reduce((lowest, image) => {
      return (lowest === null || image.display < lowest.display) ? image : lowest;
    }, null);
  };
  const [categories, setCategories] = useState([]);
  const [totalrecords, settotalrecords] = useState(0);

  useEffect(() => {
setCurrentPage(1);
  },[id])

  
  useEffect(() => {
    if (id) {
      async function fetchcategory(id) {
        try {
          let regex = /max=(\d+)/;
          let regex2 = /min=(\d+)/;
          let hasMaxPrice = regex.test(url);
          if (hasMaxPrice) {
            let match = url.match(regex);
            let match2 = url.match(regex2);

            if (match) {
              setfixmaxpriceval(match[1])
              setfixminpriceval(match2[1])
            } 
          }
          let urlapi;
          if (url == "none") {
              urlapi = `${process.env.REACT_APP_API_URL}homepageapi/product-list?cate=${id}&sort=new&page_number=${currentPage}`
              console.log("check 22")
          } else {
              console.log("check 2233")
              const getvalues = transformQuery(url);
              console.log("check url is here is not ",getvalues);
                urlapi = (`${process.env.REACT_APP_API_URL}homepageapi/product-list?cate=${id}${getvalues.sort ? `&sort=${getvalues.sort}` : ''}${getvalues.min != null ? `&min=${getvalues.min}&max=${getvalues.max}&` : `&` }${getvalues.combined_attributes}&page_number=${currentPage}`);
                // urlapi = (`${process.env.REACT_APP_API_URL}homepageapi/product-list?cate=${id}${getvalues.sort ? `&sort=${getvalues.sort}` : ''}${getvalues.min != null ? `&min=${getvalues.min}&max=${getvalues.max}&` : `&` }${getvalues.combined_attributes}&page_number=${1}`);
          }

          const config = {
            headers: {
              Authorization: `Bearer ${tokenvalue.access}`,
            },
          };
          const response = await axios.get(urlapi,config);
          settotalrecords(response.data.total_items);
          setData(response.data.results);
          if (response.data.results[0]) {
            setshowpages(true)
          }
          setloading(false);
        } catch (error) {
          setData([])
          setloading(false);

        }

      }

      async function fetchattribute(id) {
        setloading(true);
        let url2 = `${process.env.REACT_APP_API_URL}homepageapi/product-attributes/${id}/`;
        const config = {
          headers: {
            Authorization: `Bearer ${tokenvalue.access}`,
          },
        };
        const response = await axios.get(url2,config);
        setData4(response.data.data);
        setfixminprice(response.data.static_min_price);
        setfixmaxprice(response.data.static_max_price);

        let regex = /max=(\d+)/;
        let regex2 = /min=(\d+)/;
        let hasMaxPrice = regex.test(url);

        if (!hasMaxPrice) {
          setfixminpriceval(response.data.static_min_price);
          setfixmaxpriceval(response.data.static_max_price);
        }
        const updatedAttributes = {};
        response.data.data.forEach((item, index) => {
          updatedAttributes[item.name] = "";
        });
        const updatedAttributes2 = {};
        response.data.data.forEach((item, index) => {
          let finalattr = url.includes(item.name);
          if (finalattr) {
            if (item.name == "brand") {
              updatedAttributes2[item.name] = true;
            } else {
              updatedAttributes2[item.name] = true;
            }
          } else {
            if (item.name == "brand") {
              updatedAttributes2[item.name] = true;
            } else {
              updatedAttributes2[item.name] = true;
            }
          }
        });
        // setattribute((prevData) => ({
        //   ...prevData,
        //   ...updatedAttributes,
        // }));
        setshowattr((prevData) => ({
          ...prevData,
          ...updatedAttributes2,
        }));

      }
      fetchattribute(id);
      fetchcategory(id);

    }

    async function fetchcategory() {
      let url = `${process.env.REACT_APP_API_URL}cartapi/all-categoriies/`;
      const response = await axios.get(url);
      setCategories(response.data.list);
    }

    const existbred = name.includes('>');
    if (existbred) {
      const splitbred = name.split('>')
      setcategroyone(splitbred[0]);
      setcategorytwo(splitbred[1]);
    } else {
      setcategroyone(name);
      setcategorytwo('');
    }
    fetchcategory();
  }, [id, name, url,currentPage]);


  const pageCount = Math.ceil(totalrecords / 40);
  const handlePageClick = (selectedPage) => {

  };



  return <>
    <Header />
    {loading == true ? (
      <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <h2
          style={{
            textAlign: "center",
            paddingTop: "15px",
            fontWeight: "600",
            fontSize: "20px",
          }}
        >
          <Loader />
        </h2>
      </div>
    ) : (
      <>

        <div className="category-header7" style={{ zIndex: 9991 }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="category-contain">
                  <div className="category-left showandhide ">
                    <div className="header-category">
                      <a className="category-toggle">
                        <i className="fa fa-bars" />
                        pages
                      </a>
                      <ul
                        id="main-menu"
                        className={
                          showsidebar == true
                            ? "collapse-category show sm pixelstrap sm-horizontal open"
                            : "collapse-category show sm pixelstrap sm-horizontal"
                        }
                      >
                        <li
                          className="back-btn"
                          onClick={() => setshowsidebar(false)}
                        >
                          <i className="fa fa-angle-left" /> back
                        </li>

                        {categories.map((item, index) => (
 <MobileSubcategorynew value={item} setwdith={item.child.length > 0 ? 1 : 0}  /> 
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="searchbar-input ajax-search the-basics">
            <div className="input-group">
              <span className="input-group-text">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="28.931px"
                  height="28.932px"
                  viewBox="0 0 28.931 28.932"
                  style={{ enableBackground: "new 0 0 28.931 28.932" }}
                  xmlSpace="preserve"
                >
                  <g>
                    <path d="M28.344,25.518l-6.114-6.115c1.486-2.067,2.303-4.537,2.303-7.137c0-3.275-1.275-6.355-3.594-8.672C18.625,1.278,15.543,0,12.266,0C8.99,0,5.909,1.275,3.593,3.594C1.277,5.909,0.001,8.99,0.001,12.266c0,3.276,1.275,6.356,3.592,8.674c2.316,2.316,5.396,3.594,8.673,3.594c2.599,0,5.067-0.813,7.136-2.303l6.114,6.115c0.392,0.391,0.902,0.586,1.414,0.586c0.513,0,1.024-0.195,1.414-0.586C29.125,27.564,29.125,26.299,28.344,25.518z M6.422,18.111c-1.562-1.562-2.421-3.639-2.421-5.846S4.86,7.983,6.422,6.421c1.561-1.562,3.636-2.422,5.844-2.422s4.284,0.86,5.845,2.422c1.562,1.562,2.422,3.638,2.422,5.845s-0.859,4.283-2.422,5.846c-1.562,1.562-3.636,2.42-5.845,2.42S7.981,19.672,6.422,18.111z"></path>
                  </g>
                </svg>
              </span>
              <input
                type="search"
                className="form-control typeahead"
                placeholder="Search a Product"
              />
              <span className="input-group-text close-searchbar">
                <svg
                  viewBox="0 0 329.26933 329"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path>
                </svg>
              </span>
            </div>
          </div>
        </div>

        <div className="breadcrumb-main marginfromtop breadcrumbpadding">
          <div className="container m-0">
            <div className="row">
              <div className="col">
                <div className="breadcrumb-contain">
                  <div>
                    <ul>
                      <li>
                        <a href="/home">home</a>
                      </li>
                      <li style={{ fontSize: "12px" }}>&gt;</li>
                      <li>
                        <a href="javascript:void(0)">
                          {name}

                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section
          className="section-big-pt-space ratio_asos b-g-light"
          style={{ padding: "0px", background: '#f9f9f9' }}
        >
          <div className="collection-wrapper" style={{ background: "#f9f9f9" }}>
            <div className="custom-container">
              <div className="row categoryfixclass1" style={{ background: "#f9f9f9" }}>
                <div
                  className="col-sm-3 collection-filter category-page-side categoryfixclass2"
                  style={{
                    zIndex: currentwdith < 990 ? 9991 : 1,
                    left: "-15px",
                    display:
                      currentwdith < 990
                        ? filter == true
                          ? "block"
                          : "none"
                        : "block",
                    padding: "10px",
                  }}
                >
                  {/* side-bar colleps block stat */}
                  <div className="collection-filter-block creative-card creative-inner category-side">
                    {/* brand filter start */}
                    <div
                      className="collection-mobile-back"
                      onClick={() => {
                        setfilter(!filter);
                      }}
                    >
                      <span className="filter-back">
                        <i className="fa fa-angle-left" aria-hidden="true" /> back
                      </span>
                    </div>
                    <div className="collection-collapse-block open">
                      <h4>
                        CATEGORIES
                      </h4>
                      <h6 style={{ color: categorytwo == null ? `black` : `#878787`, padding: `10px 0px 10px 8px` }}>{` ${categroyone}`}</h6>
                      <h6 style={{ color: `#black`, position: 'relative', left: '10px', display: categorytwo == null ? 'none' : 'block', padding: `0 0 10px 8px` }}>{`${categorytwo}`}</h6>
                    </div>






                    {data4.map((item, index) =>
                      item.name === 'brand' ? (
                        <div key={index} className="collection-collapse-block open" style={{ display: item.values?.[0] ? 'block' : 'none' }}
                        >
                          <h3
                            className={
                              item.name.length > 6
                                ? 'collapse-block-title dynamic-after2'
                                : 'collapse-block-title dynamic-after'
                            }
                            onClick={() => {
                              showattr[item.name] === false
                                ? updateDataValue2(item.name, true)
                                : updateDataValue2(item.name, false);
                            }}
                          >
                            {item.name}
                            <style>
                              {`.dynamic-after::after {
                    left:60px;
                  }  
                  .dynamic-after2::after {
                    left:91px;
                  }`}
                            </style>
                          </h3>

                          <div
                            className="collection-collapse-block-content"
                            style={{
                              display: showattr[item.name] === true ? 'block' : 'none',
                            }}
                          >
                            <div className="collection-brand-filter">
                              <div className="lastfilter-search-container">
                                <input
                                  className="lastfilter-search__input"
                                  type="text"
                                  placeholder={`Search ${item.name}`}
                                  value={searchTerm}
                                  onChange={handleSearchChange}
                                />
                                <FaSearch className="lastfilter-search-icon" />
                              </div>
                              {filteredValues(item.values)
                                .slice(0, showAll[item.name] ? item.values.length : url.includes(`attr_name_${item.name}=${item.name}&attr_value_${item.name}=`) ? 40 : 4)
                                .map((item2, index2) => (
                                  <div
                                    key={index2}
                                    className="custom-control custom-checkbox form-check collection-filter-checkbox"
                                  >
                                    {!url.includes(
                                      `attr_name_${item.name}=${item.name}&attr_value_${item.name}=${item2.value_option__option}`
                                    ) ? (
                                      <input
                                        type="checkbox"
                                        className="custom-control-input form-check-input"
                                        onClick={() => {
                                          setpageSize(0);
                                          updateDataValue(
                                            item.name,
                                            item2.value_option__option
                                          );
                                        }}
                                        id={`item2-${index2}`}
                                      />
                                    ) : (
                                      <input
                                        type="checkbox"
                                        onClick={() => {
                                          updateDataValue(
                                            item.name,
                                            item2.value_option__option
                                          );
                                        }}
                                        className="custom-control-input form-check-input"
                                        id={`item2-${index2}`}
                                        checked
                                      />
                                    )}
                                    <label
                                      className="custom-control-label form-check-label"
                                      htmlFor={`item2-${index2}`}
                                    >
                                      {item2.value_option__option}
                                    </label>
                                  </div>
                                ))}
                              {url.includes(`attr_name_${item.name}=${item.name}&attr_value_${item.name}=`) ? '' : item.values.length > 4 && (
                                <button
                                  className="profile-edit-btn"
                                  style={{ color: `#${bgColor}`, color: `#${textColor}`, background: '#fff', fontWeight: '600' }}

                                  // style={{ background: '#fff', color: '#0cb744', fontWeight: '600' }}
                                  onClick={() => handleToggleShowAll(item.name)}
                                >
                                  {showAll[item.name] ? 'See Less' : 'See More'}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null
                    )}






                    {
                      data4.map((item, index) => (
                        item.name === "brand" ? '' : (
                          <div className="collection-collapse-block open" style={{ display: item.values?.[0] ? "block" : "none" }} key={index}>
                            <h3
                              className={
                                item.name.length > 6
                                  ? "collapse-block-title dynamic-after2"
                                  : "collapse-block-title dynamic-after"
                              }
                              onClick={() => {
                                showattr[item.name] === false
                                  ? updateDataValue2(item.name, true)
                                  : updateDataValue2(item.name, false);
                              }}
                            >
                              {item.name}
                              <style>
                                {`.dynamic-after::after { left: 60px; }
                                  .dynamic-after2::after { left: 91px; }`}
                              </style>
                            </h3>
                            <div
                              className="collection-collapse-block-content"
                              style={{
                                display: showattr[item.name] === true ? "block" : "none",
                              }}
                            >
                              <div className="collection-brand-filter">


                                <div className="lastfilter-search-container">
                                  <input
                                    className="lastfilter-search__input"
                                    type="text"
                                    placeholder={`Search ${item.name}`}
                                    value={filterQueries[item.name] || ''}
                                    onChange={(e) => handleFilterChange(item.name, e.target.value)}
                                  />
                                  <FaSearch className="lastfilter-search-icon" />
                                </div>

                                {getFilteredValues(item).slice(0, showAlltwo[item.name] ? item.values.length : url.includes(`attr_name_${item.name}=${item.name}&attr_value_${item.name}=`) ? 50 : 4).map((item2, index2) => (
                                  <div className="custom-control custom-checkbox form-check collection-filter-checkbox" key={index2}>
                                    {!url.includes(
                                      `attr_name_${item.name}=${item.name}&attr_value_${item.name}=${item2.value_option__option}`
                                    ) ? (
                                      <input
                                        type="checkbox"
                                        className="custom-control-input form-check-input"
                                        onClick={() => {
                                          setpageSize(0);
                                          updateDataValue(item.name, item2.value_option__option);
                                        }}
                                        id={`item2-${index}-${index2}`}
                                      />
                                    ) : (
                                      <input
                                        type="checkbox"
                                        onClick={() => {
                                          updateDataValue(item.name, item2.value_option__option);
                                        }}
                                        className="custom-control-input form-check-input"
                                        id={`item2-${index}-${index2}`}
                                        checked
                                      />
                                    )}
                                    <label
                                      className="custom-control-label form-check-label"
                                      htmlFor={`item2-${index}-${index2}`}
                                    >
                                      {item2.value_option__option}
                                    </label>
                                  </div>
                                ))}
                                {url.includes(`attr_name_${item.name}=${item.name}&attr_value_${item.name}=`) ? '' : item.values.length > 4 && (
                                  <button
                                    className="profile-edit-btn"
                                    style={{ color: `#${bgColor}`, color: `#${textColor}`, background: '#fff', fontWeight: '600' }}

                                    // style={{ background: '#fff', color: '#0cb744', fontWeight: '600' }}
                                    onClick={() => handleToggleShowAlltwo(item.name)}>
                                    {showAlltwo[item.name] ? 'See Less' : 'See More'}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        )
                      ))
                    }

      
                    {data4?.[0]?.name ? <div className="collection-collapse-block border-0 open" style={{display:fixmaxprice == null ? "none" : ""}}>
                      <h3
                        className="collapse-block-title dynamic-after3"
                        onClick={() => {
                          setprice(!price);
                        }}
                      >
                        price
                        <style>
                          {`.dynamic-after3::after {
            left:51px;
          }`}
                        </style>
                      </h3>

                      <p
                        style={{
                          paddingTop: "10px",
                          display: price == true ? "flex" : "none",
                          justifyContent: 'space-between'
                        }}
                      >
                        <span>Min ₹{fixminpriceval == 0 ? fixminprice : fixminpriceval}</span>
                        <span>Max ₹{fixmaxpriceval == 0 ? fixmaxprice : fixmaxpriceval}</span>
                        {/* <span> ₹{pricevalue}</span> */}
                      </p>
                      <div
                        className="collection-collapse-block-content"
                        style={{ display: price == true ? "block" : "none" }}
                      >
                        <div
                          className="filter-slide"
                          style={{ paddingTop: "10px" }}
                        >
                         {console.log("let checkdata is here",data)}
                          {data?.[0] ?
                            <ReactSlider
                              style={{ background: 'red' }}
                              className="horizontal-slider"
                              thumbClassName="example-thumb"
                              trackClassName="example-track"
                              min={parseInt(fixminprice)}

                              value={[parseInt(fixminpriceval), parseInt(fixmaxpriceval)]}
                              max={parseInt(fixmaxprice)}
                              // defaultValue={[fixminprice, fixmaxprice]}
                              ariaLabel={['Lower thumb', 'Upper thumb']}
                              ariaValuetext={state => `Thumb value ${state.valueNow}`}
                              renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                              onAfterChange={(e) => { updateDataValueforsort("max", e) }}
                              // pearling
                              onChange={(e) => { setfixminpriceval(e[0]); setfixmaxpriceval(e[1]) }}
                              minDistance={100}
                            />
                            : <ReactSlider
                              style={{ background: 'red' }}
                              className="horizontal-slider"
                              thumbClassName="example-thumb"
                              trackClassName="example-track"
                              min={parseInt(fixminprice)}

                              defaultValue={[parseInt(fixminpriceval), parseInt(fixmaxpriceval)]}

                              max={parseInt(fixmaxprice)}
                              ariaLabel={['Lower thumb', 'Upper thumb']}
                              ariaValuetext={state => `Thumb value ${state.valueNow}`}
                              renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                              onAfterChange={(e) => { updateDataValueforsort("max", e) }}
                              onChange={(e) => { setfixminpriceval(e[0]); setfixmaxpriceval(e[1]) }}
                              minDistance={100}
                            />}

                        </div>
                      </div>
                    </div> : ''}



                    {data4?.[0]?.count ? <div className="collection-collapse-block border-0 mt-4">
                      {/* <button>Clear All</button> */}
                      <input
                        style={{
                          outline: "none",
                          padding: "1px 1px",
                          fontSize: "14px",
                          fontWeight: '600',
                          color: `#${bgColor}`,

                          background: 'white'
                        }}
                        type="button"
                        onClick={() => { removefilter() }}
                        className="profile-edit-btn"
                        name="btnAddMore"
                        value="Clear All"
                      />
                    </div> : ''}













                  </div>
                </div>

                {/* filter for sort by start here */}

                <div
                  className="col-sm-3 collection-filter category-page-side"
                  style={{
                    zIndex: currentwdith < 790 ? 9991 : 1,
                    left: "-15px",
                    display:
                      currentwdith < 700
                        ? sortby == true
                          ? "block"
                          : "none"
                        : "none",
                  }}
                >
                  {/* side-bar colleps block stat */}
                  <div className="collection-filter-block creative-card creative-inner category-side">
                    {/* brand filter start */}
                    <div
                      className="collection-mobile-back"
                      onClick={() => {
                        setsortby(!sortby);
                      }}
                    >
                      <span className="filter-back">
                        <i className="fa fa-angle-left" aria-hidden="true" /> back
                      </span>
                    </div>
                    <div className="collection-collapse-block open">
                      <h3
                        className="collapse-block-title newarrow mt-0"
                        onClick={() => {
                          setbrand(!brand);
                        }}
                      >
                        Sort By
                      </h3>
                      <div
                        className="collection-collapse-block-content"
                        style={{ display: brand == true ? "block" : "none" }}
                      >
                        <div className="collection-brand-filter">
                          <div className="custom-control custom-checkbox  form-check collection-filter-checkbox">
                            {url.includes(`sort=new`) ? (
                              <input
                                type="checkbox"
                                className="custom-control-input form-check-input"
                                onClick={() => {
                                  updateDataValueforsort("sort", "new")
                                }}
                                id="item2"
                                checked
                              />
                            ) : (
                              <input
                                type="checkbox"
                                onClick={() => {
                                  updateDataValueforsort("sort", "new")
                                }}
                                className="custom-control-input form-check-input"
                                id="item2"

                              />
                            )}
                            <label
                              className="custom-control-label form-check-label"
                              htmlFor="forever-21"
                            >
                              Newest First
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox  form-check collection-filter-checkbox">
                            {url.includes(`sort=low_high`) ? (
                              <input
                                type="checkbox"
                                className="custom-control-input form-check-input"
                                onClick={() => {
                                  updateDataValueforsort("sort", "low_high")
                                }}
                                id="item2"
                                checked
                              />
                            ) : url.includes(`sort=`) ? (
                              <input
                                type="checkbox"
                                className="custom-control-input form-check-input"
                                onClick={() => {
                                  updateDataValueforsort("sort", "low_high")
                                }}
                                id="item2"
                                checked
                              />
                            ) : (
                              <input
                                type="checkbox"
                                onClick={() => {
                                  updateDataValueforsort("sort", "low_high")
                                }}
                                className="custom-control-input form-check-input"
                                id="item2"

                              />
                            )}
              
                            <label
                              className="custom-control-label form-check-label"
                              htmlFor="zara"
                            >
                              Price-Low to High
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox  form-check collection-filter-checkbox">
              
                            {url.includes(`sort=high_low`) ? (
                              <input
                                type="checkbox"
                                className="custom-control-input form-check-input"
                                onClick={() => {
                                  // updateDataValue("offset", 0);
                                  // updateDataValue("sort", "high_low");
                                  updateDataValueforsort("sort", "high_low")
                                }}
                                id="item2"
                                checked
                              />
                            ) : (
                              <input
                                type="checkbox"
                                onClick={() => {
                                  // updateDataValue("offset", 0);
                                  // updateDataValue("sort", "");
                                  updateDataValueforsort("sort", "high_low")
                                }}
                                className="custom-control-input form-check-input"
                                id="item2"

                              />
                            )}
                            <label
                              className="custom-control-label form-check-label"
                              htmlFor="vera-moda"
                            >
                              Price-High to Low
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* filter for sort by end here */}
                <div className="collection-content col">
                  <div className="page-main-content p-md-0">
                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="collection-product-wrapper"
                          style={{ background: "#f9f9f9" }}
                        >
                          <div className="product-top-filter">
                            <div
                              className="row"
                              style={{ background: "#f9f9f9" }}
                            ></div>
                            <div className="row">
                              <div className="col-12">
                                <div className="product-filter-content">
                                  <div
                                    className="search-count text-start"
                                    style={{
                                      border: "none",
                                      padding: "20px 0px 7px 0px",
                                    }}
                                  >
                                   
                                    <h5 style={{
                                      fontSize: 13,
                                      color: "black",
                                      fontWeight: 100,
                                    }}>
                                      Showing Products{" "}
                                      {Math.min((currentPage - 1) * pageSize + 1, totalrecords)}-
                                      {Math.min(currentPage * pageSize, totalrecords)}{" "}
                                      of {totalrecords} Results
                                    </h5>

                                  </div>
                                  <div
                                    className="collection-view"
                                    style={{
                                      width: "100%",
                                      paddingBottom: "0px",
                                    }}
                                  >
                                    <ul>
                                      <li
                                        style={{
                                          fontSize: 13,
                                          fontWeight: 600,
                                          paddingBottom: "4px",
                                        }}
                                      >
                                        Sort By
                                      </li>
                                      <li
                                        style={{
                                          fontSize: 13,
                                          marginRight: 12,
                                          paddingBottom: "4px",
                                          color:
                                            url.includes(`sort=new`) ? `#${bgColor}`
                                              : url.includes(`sort`) ? "" : `#${bgColor}`,
                                          fontWeight:
                                            url.includes(`sort=new`) ? "550"
                                              : url.includes(`sort`) ? "400" : "550",
                                          borderBottom:
                                            url.includes(`sort=new`) ? ` 2px solid #${bgColor}`
                                              : url.includes(`sort`) ? "" : ` 2px solid #${bgColor}`
                                        }}
                                        onClick={() => {
                                          // updateDataValue("offset", 0);
                                          updateDataValueforsort("sort", "new");
                                        }}
                                      >
                                        Newest First
                                      </li>
                                      <li
                                        style={{
                                          fontSize: 13,
                                          marginRight: 12,
                                          paddingBottom: "4px",
                                          color:
                                            url.includes(`sort=low_high`) ? `#${bgColor}`
                                              : "",
                                          fontWeight:
                                            url.includes(`sort=low_high`) ? "550"
                                              : "400",
                                          borderBottom:
                                            url.includes(`sort=low_high`) ? ` 2px solid #${bgColor}`
                                              : "",
                                        }}
                                        onClick={() => {
                                          // updateDataValue("offset", 0);
                                          updateDataValueforsort("sort", "low_high");
                                        }}
                                      >
                                        Price - Low to High
                                      </li>
                                      <li
                                        style={{
                                          fontSize: 13,
                                          marginRight: 12,
                                          paddingBottom: "4px",
                                          color:
                                            url.includes(`sort=high_low`) ? `#${bgColor}`
                                              : "",
                                          fontWeight:
                                            url.includes(`sort=high_low`) ? "550"
                                              : "400",
                                          borderBottom:
                                            url.includes(`sort=high_low`) ? ` 2px solid #${bgColor}`
                                              : "",
                                        }}
                                        onClick={() => {
                                          // updateDataValue("offset", 0);
                                          updateDataValueforsort("sort", "high_low");
                                        }}
                                      >
                                        Price - High to Low
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="product-wrapper-grid product">
                            <div className="row removepadding additionalgap" style={{ paddingBottom: data?.length < 8 ? data?.length < 4 ? '430px' : "310px" : "0px" }}>
                              {loading == true ? (
                                <h2
                                  style={{
                                    textAlign: "center",
                                    paddingTop: "15px",
                                    fontWeight: "600",
                                    fontSize: "20px",
                                  }}
                                >
                                  <Loader />
                                </h2>
                              ) : data[0] ? (
                                data.map((item, index) => {
                                  var lowestOrderImage = getLowestOrderImage(item.image);
                                  return (
                                    <div className="col-xl-3 col-md-4 col-sm-6 col-12"
                                      onMouseEnter={() => setHover([true, item?.id])}
                                      onMouseLeave={() => setHover(false)}  >
                                      <div
                                        className="bg-white catbox"
                                        style={{ margin: "3px 4px" }}
                                      >
                                        <div className="product-imgbox " style={{ position: "relative", overflow: "hidden" }}>
                                          {item.stock.stock <= 0 && (<div className="overlay" onClick={() => {
                                            transfer(item.id, item.title);
                                          }}></div>)}
                                          {item.stock.stock <= 0 && (
                                            <div className="out-of-stock" style={{ backgroundColor: `#${bgColor}` }}>Out of Stock</div>
                                          )}
                                         
                                          <div className="product-front">


                                            <button
                                              type="button"
                                              className="btn fixedhight"
                                              style={{ width: "100%" }}
                                              onClick={() => {
                                                transfer(item.id, item.title);
                                              }}
                                            >
                                              {" "}
                                              <img
                                                src={`${process.env.REACT_APP_API_URL}media/${lowestOrderImage?.ima}`}
                                                className="img-fluid  "
                                                alt="product"
                                              />

                                              {" "}
                                            </button>
                                          </div>
                                        </div>

                                        <div className="product-detail detail-center detail-inverse">
                                          <div className="detail-title">
  <div className="detail-left">
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      className="btn custom-tooltip-container"
      onClick={() => {
        transfer(item.id, item.title);
      }}
    >
      {(() => {
        const fullText = `${item.attri.filter(
            (attr) =>
              attr.code === "Brand" ||
              attr.code === "brand"
          )
          .map((attr) => attr.value)
          .join(" ")}: ${item?.title}`;

        const isMobile = window.innerWidth <= 768;
        const firstLineMax = isMobile ? 20 : 27;
        const secondLineMax = isMobile ? 40 : 60;

        const firstLine = fullText.slice(0, firstLineMax);
        let secondLine = fullText.slice(firstLineMax);

        if (secondLine.length > secondLineMax - firstLineMax) {
          secondLine = secondLine.slice(0, secondLineMax - firstLineMax) + "...";
        }

        return (
          <>
            <h6
        className="price-title catbox2"
        style={{
          color: hover[0] && hover[1] == item?.id ? '#808080' : "black",
          fontSize: "14px",
          fontWeight: "100",
          height: "40px",
          lineHeight: "20px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          maxWidth: "220px",
        }}
        onMouseEnter={() => setHover([true, item?.id])}
        onMouseLeave={() => setHover([false, null])}
      >
       <span style={{color:'green'}}> {`${item.attri
          .filter(
            (attr) =>
              attr.code === "Brand" ||
              attr.code === "brand"
          )
          .map((attr) => `${attr.value}`)
          .join(" ")}:`} </span> {item?.title}
      </h6>

          </>
        );
      })()}


      {/* tooltip code start from here  */}
      <span className="custom-tooltip-text">
        {`${item.attri.filter(
            (attr) =>
              attr.code === "Brand" ||
              attr.code === "brand"
          )
          .map((attr) => attr.value)
          .join(" ")} ${item?.title}`}
      </span>
      {/* tooltip code end from here  */}
    </button>
  </div>
</div>




                                            <div
                                              className="detail-right"
                                              style={{ width: "100%"  }}
                                            >
                                              <div
                                                className="price"
                                                style={{ width: "100%" }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    color: "#000",
                                                    fontSize: "14px",
                                                    fontWeight: '500'
                                                  }}
                                                >
                                                  {" "}
                                                <span style={{color:'#029102'}}> MRP:</span>
                                                 {new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0, 
  maximumFractionDigits: 0, 
}).format(parseInt(item?.stock?.price))}

 {item?.stock?.discount == 0 ? '' : <span style={{ fontSize: '13px', color: '#616660', lineHeight: '20px', textDecoration: 'line-through', paddingLeft: '3px', fontWeight: '400' }}>  {new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0, 
  maximumFractionDigits: 0, 
}).format(parseInt(item?.stock?.mrp))}
 </span>}{item?.stock?.discount == 0 ? '' : <span style={{ fontSize: '12px', color: 'red', lineHeight: '20px', paddingLeft: '3px', fontWeight: '400' }}>({`${item?.stock?.discount_type === "amount"
            ? `₹${item?.stock?.discount} OFF`
            : `${item?.stock?.discount}% OFF`}`})</span>}
                                                </div>
                                                <div style={{ display: "inline-block" }}>

  {/* Product Image or Other Content Here */}
</div>
 </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : (
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                  <img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/newlogo/notfound.png`}
                                    className="img-fluid  " alt="not Found" style={{ width: '36%' }} />
                                  <h2 className="newtitleh2"
                                  >
                                    But Don't Worry!! We will have Live Products on this Category Soon
                                  </h2>
                                </div>
                              )}
                            
                            </div>
                          </div>
        
                          {showpages ?
                            <div className="product-pagination">
                              <div className="theme-paggination-block">
                                <div className="row mobilemargin">
                                  <div className="col-xl-12 col-md-12 col-sm-12">
                                    <ReactPaginate
                                      pageCount={pageCount}
                                      pageRangeDisplayed={5}
                                      marginPagesDisplayed={2}
                                      onPageChange={(e) => {
                                        // console.log("check seleted page value",e)
                                        // console.log("check seleted page value 22",e.selected)
                                        setCurrentPage(e.selected + 1);
                                        filterdata(e.selected + 1);
                                      }}
                                      containerClassName="pagination"
                                      breakClassName="page-item"
                                      forcePage={currentPage - 1}
                                      activeClassName="active"
                                      pageClassName="page-item"
                                      previousLabel={
                                        <li className="page-item">
                                          <a
                                            className="page-link"
                                            href="javascript:void(0)"
                                            aria-label="Previous"
                                          >
                                            <span aria-hidden="true">
                                              <i
                                                className="fa fa-chevron-left"
                                                aria-hidden="true"
                                              />
                                            </span>{" "}
                                            <span className="sr-only">
                                              Previous
                                            </span>
                                          </a>
                                        </li>
                                      }
                                      nextLabel={
                                        <li className="page-item">
                                          <a
                                            className="page-link"
                                            href="javascript:void(0)"
                                            aria-label="Next"
                                          >
                                            <span aria-hidden="true">
                                              <i
                                                className="fa fa-chevron-right"
                                                aria-hidden="true"
                                              />
                                            </span>{" "}
                                            <span className="sr-only">Next</span>
                                          </a>
                                        </li>
                                      }
                                    />
                                  </div>
                                 
                                </div>
                              </div>
                            </div>
                            : ''}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="header7 bottomdgn" style={{ zIndex: '4' }}>
                  <div className="custom-container">
                    <div className="row">
                      <div className="col-12">
                        <div
                          className="header-contain"
                          style={{ padding: "8px 0px 0px 0px" }}
                        >
                          <div
                            className="collection-product-wrapper"
                            style={{ width: "100%" }}
                          >
                            <div className="product-top-filter">
                              <div className="row">
                                <div
                                  className="col-xl-12"
                                  style={{
                                    paddingTop: "10px",
                                    display: "flex",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  <div
                                    className=""
                                    onClick={() => {
                                      setfilter(!filter);
                                    }}
                                  >
                                    <span
                                      className="filter "
                                      style={{ paddingright: "100px", color: `#${textColor}` }}
                                    >
                                      <i
                                        className="fa fa-filter"
                                        aria-hidden="true"
                                        style={{
                                          fontSize: "24px",
                                          color: `#${textColor}`
                                        }}
                                      />
                                    </span>
                                  </div>

                                  <div
                                    className="toggle-nav"
                                    style={{ justifyContent: "center", color: `#${textColor}` }}
                                    onClick={() => setshowsidebar(!showsidebar)}
                                  >
                                    <i className="fa fa-bars sidebar-bar" style={{ color: `#${textColor}` }} />
                                  </div>

                                  <div className="collection-collapse">
                                    <h3
                                      className="collapse-block-title mt-0"
                                      onClick={() => {
                                        setsortby(!sortby);
                                      }}
                                    >
                                      <i
                                        class="fa-solid fa-arrow-down-wide-short"
                                        style={{ color: `#${textColor}` }}
                                        onClick={() => {
                                          setsortby(!sortby);
                                        }}
                                      />
                                    </h3>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* section End */}

        {/* <Footer /> */}
      </>
    )}</>
};

export default CategoryMini;


